import {
  CLEAR_PICKLIST_STATE,
  SET_PICKLIST_FILTER,
  SET_PICKLIST_CREATION_FORM
} from 'constants/reduceConstants';

const initialState = {
  // Summary Screen
  filter: { responseReceived: false },
  // Edit Screen
  creationForm: {}
};

const pickListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PICKLIST_FILTER:
      return { ...state, filter: payload };
    case SET_PICKLIST_CREATION_FORM:
      return { ...state, creationForm: payload };
    case CLEAR_PICKLIST_STATE:
      return { ...initialState, filter: { ...state.filter, responseReceived: false } };
    default:
      return state;
  }
};

export default pickListReducer;
